import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import your CSS file here at the top
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './Redux/Store';
import Provider from 'react-redux/es/components/Provider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
